import React from 'react'
import styled from 'styled-components'
import DevView from './DevView'
import ProjectHeader from './ProjectHeader'

function CompleteView(props) {
    return (
        <div className="w100">
            <ProjectHeader pg={props.pg} viewTitle="프로젝트 완료" />

            <ReportBlock>
                <DevView {...props} nums={5} hideHeader={true} />
            </ReportBlock>

            <ReportBlock>
                <DevView {...props} nums={6} hideHeader={true} />
            </ReportBlock>

            <ReportBlock last>
                <DevView {...props} nums={7} hideHeader={true} />
            </ReportBlock>
        </div>
    )
}

export default CompleteView

const ReportBlock = styled.div`
    margin-bottom: 26px;
    /* padding-bottom: 26px; */
    border-bottom: ${(props) => (props.last ? 'none' : '1px solid #d9d9d9')};
`
